import { Injectable, inject } from '@angular/core';
import {APIService} from "./api.service";
import {AuthService} from "./auth.service";
import {ToastUIEditorComponent, TUI_TOOLBAR} from "../../oex-ui-kit/components/toastui-editor/toastui-editor.component";
import {NotificationsService} from "../../oex-ui-kit/services/notifications.service";

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  private api = inject(APIService);
  private auth = inject(AuthService);
  private ns = inject(NotificationsService);


  async initialize() {
    this.ns.showSettings.set(false);
    // Change TUI toolbar
    ToastUIEditorComponent.changeToolbar(
      ['heading', 'bold', 'italic', 'strike'],
      ['hr', 'quote'],
      ['ul', 'ol', 'indent', 'outdent'],
      ['link']
    );
    ToastUIEditorComponent.defaultUploadEndpoint = this.api.getEditorImageUploadEndpoint();
    try {
      await Promise.all([
        this.auth.initializeUserState()
      ])
    } catch (e) {
      console.error(e);
    }
    return Promise.resolve();
  }
}
